import {Component, OnInit} from '@angular/core';
import {Merchant, MerchantPhone, MerchantSocialMediaPlatform} from "../../../../common/interfaces/Merchant";
import {Product} from "../../../../common/interfaces/Product";
import {ActivatedRoute, Router} from "@angular/router";
import {MerchantService} from "../../../../common/services/merchant.service";
import {SocialMediaPlatform} from "../../../../common/enums/SocialMediaPlatform";

@Component({
  selector: 'merchant-home-tab',
  templateUrl: './merchant-home-tab.component.html',
  styleUrls: ['./merchant-home-tab.component.scss']
})
export class MerchantHomeTabComponent implements OnInit {

  merchant: Merchant | null
  products: Product[] = []
  slugId: string = ""

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private merchantService: MerchantService
  ) {
  }

  ngOnInit(): void {
    this.slugId = this.route.parent?.snapshot.params['slug']
    this.merchantService.getMerchantInfo().subscribe({
      next: (merchant) => {
        this.merchant = merchant
        this.products = merchant?.topProducts ?? []
      }
    })
  }


  openPlatform(socialMediaPlatform: MerchantSocialMediaPlatform) {
    window.open(socialMediaPlatform.url, "_blank")
  }

  getSocialMediaIcon(socialMediaPlatform: MerchantSocialMediaPlatform): string {
    if (socialMediaPlatform.platform === SocialMediaPlatform.YOUTUBE) {
      return "assets/youtube-channel-icon.svg"
    } else if (socialMediaPlatform.platform === SocialMediaPlatform.FACEBOOK) {
      return "assets/facebook-page-icon.svg"
    } else if (socialMediaPlatform.platform === SocialMediaPlatform.X) {
      return "assets/twitter-page-icon.svg"
    } else if (socialMediaPlatform.platform === SocialMediaPlatform.TIKTOK) {
      return "assets/tik-tok-icon.svg"
    } else if (socialMediaPlatform.platform === SocialMediaPlatform.INSTAGRAM) {
      return "assets/instagram-page-icon.svg"
      // } else if (socialMediaPlatform.platform === SocialMediaPlatform.WEBSITE) {
      //   return "assets/website-icon.svg"
    } else {
      return ""
    }
  }

  // hasTelegramIcon(merchantPhone: MerchantPhone): string {
  //   if (merchantPhone.hasTelegram === 1) {
  //     return "assets/telegram-icon.svg"
  //   } else {
  //     return "assets/telegram-inactive-icon.svg"
  //   }
  // }
  //
  // hasWhatsappIcon(merchantPhone: MerchantPhone): string {
  //   if (merchantPhone.hasWhatsapp === 1) {
  //     return "assets/whats-app-icon.svg"
  //   } else {
  //     return "assets/whats-app-inactive-icon.svg"
  //   }
  // }

  hasTelegramIcon(merchantPhone: MerchantPhone): boolean {
    return merchantPhone.hasTelegram === 1;
  }

  hasWhatsappIcon(merchantPhone: MerchantPhone): boolean {
    return merchantPhone.hasWhatsapp === 1;
  }

  openMenuTab() {
    this.router.navigate([`/page/${this.slugId}/menu`,]).then(_ => {

    });
  }

  merchantBriefExists(): boolean {
    return !!(this.merchant !== null && this.merchant !== undefined && this.merchant.brief?.hasActualValue());
  }

  merchantMediaExists(): boolean {
    return (this.merchant !== null && this.merchant.socialMediaPlatforms !== null && this.merchant.socialMediaPlatforms.isNotEmpty())
  }

}
